import { jsx as _jsx } from "react/jsx-runtime";
import { contentCollectionApplyAllSelector } from "@air/feature-content-collection/redux";
import { Pencil as PencilIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useAirModal } from "@air/provider-modal";
import { hasSelectedItemsSelector } from "@air/redux-selected-items";
import { memo } from "react";
import { useSelector } from "react-redux";
import { BoardCollectionGalleryAssetDetailsModal } from "~/components/BoardCollection/BoardCollectionGalleryAssetDetailsModal";
import { boardCollectionFormSelector } from "~/store/boardCollection/selectors";
import { selectedClipsSelector } from "~/store/selectedItems/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
export const ContentCollectionEditCustomFieldsButton = /*#__PURE__*/ memo(()=>{
    const store = useAirStore();
    const hasSelectedItems = useSelector(hasSelectedItemsSelector);
    const applyAll = useSelector(contentCollectionApplyAllSelector);
    const { isAboveMediumScreen } = useBreakpointsContext();
    const [showBoardCollectionGalleryAssetDetailsModal] = useAirModal(BoardCollectionGalleryAssetDetailsModal);
    const form = useSelector(boardCollectionFormSelector);
    if (!(form === null || form === void 0 ? void 0 : form.fields.some((field)=>field.type === "custom_field")) || applyAll) {
        return null;
    }
    if (isAboveMediumScreen) {
        return /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            /**
         * @TODO - Talked w/ design, this is a quick-fix here for content collection. We're going to be redoing disabled states in the next coming weeks.
         */ className: "disabled:bg-transparent disabled:opacity-40",
            "data-testid": "CONTENT_COLLECTION_EDIT_CUSTOM_FIELDS",
            disabled: !hasSelectedItems,
            size: "large",
            prefix: /*#__PURE__*/ _jsx(PencilIcon, {
                className: "size-4"
            }),
            onClick: ()=>showBoardCollectionGalleryAssetDetailsModal({
                    clips: selectedClipsSelector(store.getState())
                }),
            children: "Edit fields"
        });
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        color: "grey",
        /**
       * @TODO - Talked w/ design, this is a quick-fix here for content collection. We're going to be redoing disabled states in the next coming weeks.
       */ className: "disabled:bg-transparent disabled:opacity-40",
        "data-testid": "CONTENT_COLLECTION_EDIT_CUSTOM_FIELDS",
        disabled: !hasSelectedItems,
        icon: PencilIcon,
        label: "Edit",
        onClick: ()=>showBoardCollectionGalleryAssetDetailsModal({
                clips: selectedClipsSelector(store.getState())
            }),
        size: "large"
    });
});
ContentCollectionEditCustomFieldsButton.displayName = "ContentCollectionEditCustomFieldsButton";
